// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1CsEq","signatureBlock":"Footer_signatureBlock__1a-UD","signature":"Footer_signature__2m6J6"};